<ng-container [formGroup]="formGroup">

  <!-- Standard View -->
  <div *ngIf="!isModalView">

    <ng-template *ngTemplateOutlet="isAny"></ng-template>

    <ng-template *ngTemplateOutlet="rules"></ng-template>
    
    <!-- Add a rule -->
    <div class="d-flex justify-content-end mt-4">
      <yc-button 
        [primary]="true"
        [langKey]="'CONFIG:btnAddARule'"
        [fontAwesomeIcon]="'plus'"
        [defaultText]="'Add a rule'"
        (onClick)="addRule()">
      </yc-button>
    </div>
  </div>

  <!-- Modal View -->
  <div *ngIf="isModalView"
    class="rules-wrapper">
    <!-- Rule Overview -->
    <div class="rules-overview"
      [class.rule-summary-hidden]="!showRuleSummary || !hasValidSummaryRule"
      [class.no-visible-rules]="!hasRulesForDisplay">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <ng-template *ngTemplateOutlet="isAny"></ng-template>
        </div>
        <div>
          <!-- Show Rule Summary -->
          <yc-button
            [link]="true"
            class="me-3"
            [langKey]="showRuleSummary ? 'common:textHideRuleSummary' : 'common:textShowRuleSummary'"
            [defaultText]="showRuleSummary ? 'Hide rule summary' : 'Show rule summary'"
            [fontAwesomeIcon]="showRuleSummary ? 'caret-up' : 'caret-down'"
            (onClick)="showRuleSummary = !showRuleSummary">
          </yc-button>
        </div>
      </div>
      <!-- Rule Summary -->
      <div *ngIf="showRuleSummary && hasValidSummaryRule" 
        class="ms-3">
        <gc-automation-rule-summary
          [uiRules]="rulesFormArray.value">
        </gc-automation-rule-summary>
      </div>
    </div>

    <!-- Rules -->
    <div class="rules"
      [class.no-visible-rules]="!hasRulesForDisplay"
      [class.justify-content-center]="!hasRulesForDisplay"
      [class.rule-summary-hidden]="!showRuleSummary || !hasValidSummaryRule">
      <ng-template *ngTemplateOutlet="rules"></ng-template>
    </div>

    <!-- Rules Footer -->
    <div class="rules-footer">
      <!-- Add Rule -->
      <yc-button
        class="ms-3 me-2"
        [secondary]="true"
        [langKey]="'common:btnAddRule'"
        [defaultText]="'Add rule'"
        (onClick)="addRule()">
      </yc-button>

      <!-- More Options -->
      <div class="btn-group me-2" dropdown>
        <yc-button dropdownToggle
          [secondary]="true"
          [value]="'common:btnOptions' | ycI18n">
          <yc-i18n
            key="NAV:textMore"
            defaultValue="More">
          </yc-i18n>
          <yc-fa icon="chevron-down" class="ms-2 dropdown-arrow dropdown-right"></yc-fa>
        </yc-button>

        <ul *dropdownMenu
          class="dropdown-menu dropdown-left"
          role="menu">        
          <!-- Manage Detail  -->
          <li *ngIf="formArrayValid"
            role="menuitem"
            class="dropdown-item"
            [ycTrackClick]="'Edit route'"
            (click)="onEditRuleset.emit()">
            <yc-fa
              icon="pencil"
              [light]="true"
              class="text-link me-2">
            </yc-fa>
            <yc-i18n
              key="common:textManageDetail"
              defaultValue="Manage detail">
            </yc-i18n>
          </li>

          <!-- Delete Route -->
          <li *ngIf="canDeleteRuleset"
            role="menuitem"
            class="dropdown-item"
            [ycTrackClick]="'Delete route'"
            (click)="onDeleteRuleset.emit()">
            <yc-fa
              icon="times"
              [light]="true"
              class="text-danger me-2">
            </yc-fa>
            <yc-i18n
              key="common:textDeleteRoute"
              defaultValue="Delete route">
            </yc-i18n>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <ng-template #rules>
    <ng-container *ngIf="objects">
      <!-- One Rule Required Text -->
      <yc-i18n *ngIf="requireOneRule &&
        totalNonDeleted === 0 &&
        !noRulesTemplate"
        class="mt-2 text-danger d-block"
        key="CONFIG:lblYouMustEnterOneRule2"
        defaultValue="You must enter at least one rule">
      </yc-i18n>

      <!-- No Rules Template -->
      <div *ngIf="noRulesTemplate && !hasRulesForDisplay">
        <ng-container *ngTemplateOutlet="noRulesTemplate"></ng-container>
      </div>
      
      <ng-container *ngFor="let group of rulesFormArray.controls; let index = index;">
        <div *ngIf="!group.value.isRemoved"
          class="ms-4 mt-3">
          {{ group.value.ruleLabel }}
        </div>
        <gc-automation-criteria *ngIf="!group.value.isRemoved"
          [criteriaFormGroup]="rulesFormArray.at(index)"
          [usedColumns]="usedColumns"
          [isModalView]="isModalView"
          [objects]="objects"
          [ruleIndex]="index"
          (columnChanged)="columnChanged($event, index)"
          (onRemove)="removeRule(index)">
        </gc-automation-criteria>
      </ng-container>
      <div id="scroll-to-target"></div>
    </ng-container>
  </ng-template>


  <ng-template #isAny>
    <div class="d-flex align-items-center justify-content-start mb-2 pb-2 ps-3"
      [class.border-bottom]="!isModalView">
      {{ isAnyLabel }}
      <yc-typeahead-select
        class="ms-1 me-1"
        name="isAny"
        [label]="isAnyLabel"
        [srOnlyLabel]="true"
        [items]="isAnyOptions"
        (onChange)="applyRulesWithOrChange.emit($event)">
      </yc-typeahead-select>
      <yc-i18n
        key="CONFIG:lblOfTheFollowingAreMet"
        defaultValue="of the following are met">
      </yc-i18n>
    </div>
  </ng-template>

</ng-container>
